module.exports = __webpack_public_path__ + "static/media/roundCheck.b2dcb3a9.svg";